export default __webpack_public_path__ + "static/media/errorData.610b359d.svg";